import { action, observable, set } from "mobx";
import moment from "moment";
import Model from "~/models/Model";
import Invoice from "~/models/Invoice/Invoice";
import Provider from "~/models/Provider";
import CreditAccount from "~/models/Credit/CreditAccount";

class CreditCardTransaction extends Model {
  /**
   * @property {number|null}
   */
  @observable creditCardTransactionId = null;

  /**
   * @property {number|null}
   */
  @observable amount = null;

  /**
   * @property {number|null}
   */
  @observable transactionId = null;

  /**
   * @property {string|null}
   */
  @observable currency = null;

  /**
   * @property {number|null}
   */
  @observable invoiceId = null;

  /**
   * @property {string|null}
   */
  @observable approval = null;

  /**
   * @property {Invoice|null}
   */
  @observable invoice = null;

  /**
   * @property {string|null}
   */
  @observable stripeReceiptUrl = null;

  /**
   * @property {Provider|null}
   */
  @observable provider = null;

  /**
   * @property {CreditAccount|null}
   */
  @observable creditAccount = null;

  /**
   * @property {string|null}
   */
  @observable creationDts = null;

  /**
   * Set new data to our model
   * @override
   * @param {object} data
   */
  @action
  setData(data) {
    const { creationDts, invoice, provider, creditAccount, ...rest } = data;
    set(this, rest);

    this.creationDts = creationDts ? moment.unix(creationDts) : null;
    this.invoice = invoice ? new Invoice(invoice) : null;
    this.provider = provider ? new Provider(provider) : null;
    this.creditAccount = creditAccount ? new CreditAccount(creditAccount) : null;
  }
}

export default CreditCardTransaction;
